import { Navigate, useLocation } from '@suntex.core/nav';

/**
 * Normalizes bare `/player`, unmatched `/player/*`, and legacy
 * `/player/:playerId/*` paths, preserving query string and hash. The player is
 * always taken from the login, so a leading numeric id segment is stripped;
 * anything that isn't a known page is funneled through the dashboard so legacy
 * short links (e.g. `/player/ss/3`) still resolve.
 */
export function PlayerDashboardRedirect() {
  const { pathname, search, hash } = useLocation();
  const subPath = pathname.replace(/^\/player\/?/, '');
  const idMatch = subPath.match(/^\d+(?:\/(.*))?$/);
  let target: string;
  if (idMatch) {
    const rest = idMatch[1] ?? '';
    target = rest ? `/player/${rest}` : '/player/dashboard';
  } else {
    target = subPath ? `/player/dashboard/${subPath}` : '/player/dashboard';
  }

  return <Navigate to={`${target}${search}${hash}`} replace />;
}
